import TextArea from './textarea'

export default TextArea


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit-fields/src/components/textarea/index.js
// module id = null
// module chunks = 